import React, { FC, useState } from 'react';
import { Video } from './Video';
import { configuration } from 'config/constants';
import { DefaultTooltip } from 'components/common/tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Keyboard } from 'swiper/modules';

import 'swiper/css';
import './ScreenshotCarousel.scss';

type ScreenshotCarouselProps = {
    images?: string[];
    videoId?: string;
};

export const ScreenshotCarousel: FC<ScreenshotCarouselProps> = ({
    images,
    videoId,
}) => {
    const { infoUrl } = configuration;
    const slideLength = [...(images ?? []), videoId].filter(x => !!x).length;

    if (slideLength === 0) {
        return false;
    }

    return (
        <div className="d-flex mb-5 screenshot-carousel">
            <Swiper
                keyboard={true}
                modules={[Keyboard]}
            >
                {videoId && <SwiperSlide>
                    <Video videoId={videoId} />
                </SwiperSlide>}
                {images?.map((image) => {
                    const imageUrl = image.startsWith('https://') ? image : `${infoUrl}/images/services/${image}`;
                    return (
                        <SwiperSlide key={image}>
                            <div className="text-center">
                                <img src={imageUrl} className="mw-100 mh-100" alt="service screenshot" />
                            </div>
                        </SwiperSlide>
                    );
                })}
                {slideLength > 1 && <Controls />}
            </Swiper>
        </div>
    );
};

const Controls: FC = () => {
    const { t: translate } = useTranslation('tooltip');
    const [forceRender, setForceRender] = useState(0);

    // Don't decompose swiper: it's a class, and decompose it will break all methods
    const swiper = useSwiper();

    // swiper hook don't work properly. it's more like a ref than a hook
    // if a property is updated, the component is NOT rerender (tested is v11)
    swiper.onAny(() => setForceRender(forceRender + 1));

    return (
        <>
            <DefaultTooltip
                text={translate('tooltip:prev')}
                placement="top"
                enabled={!swiper.isBeginning}
            >
                <button
                    id="screenshotCarouselPrev"
                    className="btn carousel-control-wrapper carousel-control-wrapper-prev"
                    onClick={() => swiper.slidePrev()}
                    disabled={swiper.isBeginning}
                >
                    <span className="bg-opacity-20 bg-secondary carousel-control-prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="d-none">prev</span>
                    </span>
                </button>
            </DefaultTooltip>
            <DefaultTooltip
                text={translate('tooltip:next')}
                placement="top"
            >
                <button
                    id="screenshotCarouselNext"
                    className="btn carousel-control-wrapper carousel-control-wrapper-next"
                    onClick={() => swiper.slideNext()}
                    disabled={swiper.isEnd}
                >
                    <span className="bg-opacity-20 bg-secondary carousel-control-next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="d-none">next</span>
                    </span>
                </button>
            </DefaultTooltip>
        </>
    );
};